<template>
  <div class="absolute top-0 left-0 right-0 m-1">
    <ul aria-label="Assessment progress"
      class="flex flex-row m-0 h-2 pl-1"
    >
      <li v-for="index in progresscount"
        class="flex-grow h-full border mr-1 mb-0 rounded-full"
        :class="index <= progresscomplete ? 'bg-green-400 border-green-400 shadow' : 'border-gray-500 bg-gray-700'"
        :aria-current="index == progresscomplete + 1 ? 'step' : null"
        :key="index"
      >
        <span class="hidden">{{ index <= progresscomplete ? 'Completed' : 'Not completed' }}</span>
      </li>
    </ul>

    <div class="text-xs text-left text-gray-300 px-1 py-2">
      {{ progresscomplete }} of {{ progresscount }} steps completed
    </div>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {

        props: {
            counttotal: '',
            countcomplete: '',
        },

        data() {
          return {
            progresscount: Number(this.counttotal),
            progresscomplete: Number(this.countcomplete),
          }
        },

        methods: {

          postItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.post(
                  this.route.replace("selected.id", this.selected.id)
                ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },

    }
</script>
